
  <section class="wellcome_area clearfix" id="home">
        <div class="container h-100">
            <div class="row h-100 align-items-center">
                <div class="col-md-9">
                    <div class="col-md-8">
                      <img src="images/bg-img/maybank2upay_logo.png" alt="" class="mb-15" />
                      <!-- Form Start -->
                          <h4 class="home-banner-text white">Power Your Business Today</h4>
                          <h4 class="mb-30 white">with our payment solution</h4>
                          
                          <a routerLink="/register"><button *ngIf="!authenticated" type="submit" class="btn submit-btn mb-30">SIGN UP NOW</button></a>

                          <a routerLink="/dashboard"><button *ngIf="authenticated" type="submit" class="btn submit-btn mb-30">MY DASHBOARD</button></a>
                        
                        <!-- Form End -->
                    </div>
                    <div class="icons col-xs-0 col-md-4">
                      
                       
                    </div>
                    
                </div>
            </div>
        </div>
        <!-- Welcome thumb -->
        <div class="welcome-thumb wow fadeInDown" data-wow-delay="0.5s"> </div>
    </section>
    <!-- ***** Wellcome Area End ***** -->

    <!-- ***** Special Area Start ***** -->
    <section class="special-area bg-beige section_padding_100" id="features">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <!-- Section Heading Area -->
                    <div class="section-heading text-center">
                      <h2>More ways to pay.</h2>
                        <div class="line-shape"></div>
                    </div>
                    <div class="client-description text-center">  
                      <p>We offer a range of convenient ways for you to get paid.</p>
                                <!-- <p>We offer a range of convenient ways for you to get paid, and get your money faster!</p> -->
                  </div>
                </div>
            </div>

            <div class="col-xs-12  col-sm-12 col-md-12">
                <!-- Single Special Area -->
                <div class="col-xs-12 col-sm-12 col-md-4">
                  <div class="single-special text-center wow fadeInUp" data-wow-delay="0.2s">
                        <div class="single-icon"><img src="images/bg-img/methods.png" alt="" class="pay-now"></div>
                        <h4>More payment methods</h4>
                        <p>Your customer can now pay using current/saving account or any bank’s cards, including payment with instalment plan.</p>
                  </div>
                </div>
                <!-- Single Special Area -->
                <div class="col-xs-12 col-sm-12 col-md-4">
                    <div class="single-special text-center wow fadeInUp" data-wow-delay="0.4s">
                       <div class="single-icon"><img src="images/bg-img/flash.png" alt="" class="pay-now"></div>
                       
                        <h4>Get money faster</h4>
                        <p>You will receive money from the bank on next working day of the transaction.</p>
                        
                    </div>
                </div>
                <!-- Single Special Area -->
                <div class="col-xs-12 col-sm-12 col-md-4">
                    <div class="single-special text-center wow fadeInUp" data-wow-delay="0.6s">
                      <div class="single-icon"><img src="images/bg-img/writing.png" alt="" class="add-more"></div>
                        <h4>Know what’s going on</h4>
                        <p>Easily identify your day to day transactions through detailed online report.<br>
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <!-- Special Description Area -->
        <!-- <div class="special_description_area mt-50">
            <div class="container">
                <div class="row">
                    <div class="col-lg-6">
                        <div class="special_description_img">
                            <img src="images/bg-img/animat-swiss-knife.gif" alt="">
                        </div>
                    </div>
                    <div class="col-lg-6 col-xl-5 ml-xl-auto">
                        <div class="special_description_content">
                          <h2>Everything connects, and it all makes sense.</h2>
                          <p>Trusting Maybank2u Pay as a single payment provider keeps everything under one roof. Configurations and solutions for every size and type of business, from Private Limited to SMEs.</p>
                            
                        </div>
                    </div>
                </div>
            </div>
        </div> -->
    </section>
    <!-- ***** Special Area End ***** -->

    <!-- ***** Awesome Features Start ***** -->
    <section class="awesome-feature-area bg-white section_padding_0_50 clearfix" id="benefits">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <!-- Heading Text -->
                    <div class="section-heading text-center">
                      <h2>Benefits</h2>
                        <div class="line-shape"></div>
                    </div>
                </div>
            </div>

            <div class="col-md-12">
                
                <!-- Single Feature Start -->
                <div class="col-sm-12 col-lg-3">
                    <div class="single-feature">
                      <i class="ti-arrow-down" aria-hidden="true"></i>
                        <h5>Competitive transaction fee</h5>
                        <p>Apply directly to Maybank with Zero Setup Cost and enjoy competitive transaction fee.</p>
                        
                        <p class="benefits-subtext"><i></i></p>
                  </div>
                </div>
                <!-- Single Feature Start -->
                <div class="col-sm-12 col-lg-3">
                    <div class="single-feature">
                        <i class="ti-flag" aria-hidden="true"></i>
                        <h5>Payment solutions for every need</h5>
                        <p>Designed for both online and retail business. </p>
                  </div>
                </div>
                <!-- Single Feature Start -->
              <div class="col-sm-12 col-lg-3">
                    <div class="single-feature">
                        <i class="ti-heart" aria-hidden="true"></i>
                        <h5>Pay with confidence<br/><br/></h5>
                        <p>Your customer will have better confidence to make payment when they see familiar and trusted bank.</p>
                  </div>
                </div>
                <!-- Single Feature Start -->
                <div class="col-sm-12 col-lg-3">
                    <div class="single-feature">
                      <i class="ti-eye" aria-hidden="true"></i>
                        <h5>Security matters<br/><br/></h5>
                        <p>Peace of mind is guaranteed because we provide privacy and data protection.</p>
                         <!-- <p>Peace of mind is guaranteed because privacy and data protection is of great importance to Maybank</p> -->
                  </div>
                </div>
            </div>

        </div>
    </section>
    <!-- ***** Awesome Features End ***** -->

    <!-- ***** Pricing Plane Area Start *****==== -->
    <section class="pricing-plane-area section_padding_100_70 clearfix" id="products">
        <div class="container">
            <div class="col-12">
                <div>
                    <!-- Heading Text  -->
                    <div class="section-heading text-center">
                      <h2>Our Solutions</h2>
                        <div class="line-shape"></div>
                    </div>
                    <div>
                      <div class="client-description text-center">
                        <!-- <p>Maybank2u Pay offers four product bundles. <br>
Your customer will enjoy simple, secure and fast payments.<br><br>
                       
                       </p> -->
                       <h5>Choose your type of business to get started.</h5>
                      </div>
                    </div>
                </div>
            </div>

            <div class="col-md-12 no-gutters">
                <div class="col-sm-12 col-md-6 col-lg-3">
                    <!-- Package Price  -->
                    <div class="single-price-plan text-center">
                        <!-- Package Text  -->
                        <div class="package-plan">
                        <div class="client-thumbnail">
                            <img src="images/bg-img/icons-02.png" alt="">
                        </div>
                        <div class="ca-price d-flex justify-content-center">
                          <h5><strong>Online Store</strong></h5>
                        </div>
                        <p style="height: 100px;">You run an online business and you need to accept online payment.</p>
                        </div>
                        <!-- Plan Button  -->
                        <div class="plan-button">
                            <a *ngIf="authenticated" routerLink="/chooseBusiness">Apply Now</a>
                            <a *ngIf="!authenticated" routerLink="/login">Apply Now</a>
                        </div>
                        <div class="package-description">
                          <p><span [attr.data-tooltip]="SERVICE_DESC['Online Banking']?.desc">Online Banking&nbsp;<i class="ti-info-alt" aria-hidden="true"></i></span></p>
                          <p><span [attr.data-tooltip]="SERVICE_DESC['Cards Payment Gateway']?.desc">Cards Payment Gateway&nbsp;<i class="ti-info-alt" aria-hidden="true"></i></span></p>
                          
                        </div>
                        
                    </div>
                </div>
                <div class="col-sm-12 col-md-6 col-lg-3">
                    <!-- Package Price  -->
                    <div class="single-price-plan text-center">
                        <!-- Package Text  -->
                      <div class="package-plan">
                       <div class="client-thumbnail">
                         <img src="images/bg-img/icons-01.png" alt="">
                        </div>
                            <div class="ca-price d-flex justify-content-center">
                              <h5><strong>Retail</strong></h5>
                            </div>
                        <p style="height: 100px;">You have a physical presence and you need to accept payment in-store.</p>
                      </div>
                      <!-- Plan Button  -->
                        <div class="plan-button">
                            <a *ngIf="authenticated" routerLink="/chooseBusiness">Apply Now</a>
                            <a *ngIf="!authenticated" routerLink="/login">Apply Now</a>
                        </div>
                      <div class="package-description">
                          <p><span [attr.data-tooltip]="SERVICE_DESC['POS Terminal']?.desc">POS Terminal&nbsp;<i class="ti-info-alt" aria-hidden="true"></i></span></p>
                          <p><span [attr.data-tooltip]="SERVICE_DESC['mPOS']?.desc">mPOS&nbsp;<i class="ti-info-alt" aria-hidden="true"></i></span></p>

                          <p><span [attr.data-tooltip]="SERVICE_DESC['QRPayBiz']?.desc">QRPayBiz&nbsp;<i class="ti-info-alt" aria-hidden="true"></i></span></p>
                      </div>
                        
                    </div>
                </div>
                <div class="col-sm-12 col-md-6 col-lg-3">
                    <!-- Package Price  -->
                    <div class="single-price-plan text-center">
                        <!-- Package Text  -->
                      <div class="package-plan">
                        <div class="client-thumbnail">
                            <img src="images/bg-img/icons-03.png" alt="">
                        </div>
                        <div class="ca-price d-flex justify-content-center">
                          <h5><strong>Online Store + Retail</strong></h5>
                        </div>
                        <p style="height: 100px;">You have both physical and online business presence and you need to accept payment in-store and online.</p>
                      </div>
                      <!-- Plan Button  -->
                        <div class="plan-button">
                          <a *ngIf="authenticated" routerLink="/chooseBusiness">Apply Now</a>
                            <a *ngIf="!authenticated" routerLink="/login">Apply Now</a>
                        </div>
                      <div class="package-description">
                          
                         <p><span [attr.data-tooltip]="SERVICE_DESC['Online Banking']?.desc">Online Banking&nbsp;<i class="ti-info-alt" aria-hidden="true"></i></span></p>
                          <p><span [attr.data-tooltip]="SERVICE_DESC['Cards Payment Gateway']?.desc">Cards Payment Gateway&nbsp;<i class="ti-info-alt" aria-hidden="true"></i></span></p>
                          <p><span [attr.data-tooltip]="SERVICE_DESC['POS Terminal']?.desc">POS Terminal&nbsp;<i class="ti-info-alt" aria-hidden="true"></i></span></p>
                          <p><span [attr.data-tooltip]="SERVICE_DESC['mPOS']?.desc">mPOS&nbsp;<i class="ti-info-alt" aria-hidden="true"></i></span></p>
                          
                           <p><span [attr.data-tooltip]="SERVICE_DESC['QRPayBiz']?.desc">QRPayBiz&nbsp;<i class="ti-info-alt" aria-hidden="true"></i></span></p>
                      </div>
                        
                    </div>
                </div>
                <div class="col-sm-12 col-md-6 col-lg-3">
                    <!-- Package Price  -->
                    <div class="single-price-plan text-center">
                        <!-- Package Text  -->
                        <div class="package-plan">
                        <div class="client-thumbnail">
                            <img src="images/bg-img/icons-04.png" alt="">
                        </div>
                        <div class="ca-price d-flex justify-content-center">
                          <h5><strong>Others</strong></h5>
                        </div>
                        <p style="height: 100px;">You need other payment services like JomPAY, AutoDebit and Maybank2u Biller.</p>
                        </div>
                        <!-- Plan Button  -->
                        <div class="plan-button">
                            <a *ngIf="authenticated" routerLink="/chooseBusiness">Apply Now</a>
                            <a *ngIf="!authenticated" routerLink="/login">Apply Now</a>
                        </div>
                        <div class="package-description">
                         <!--  <p><span [attr.data-tooltip]="SERVICE_DESC['FPX']?.desc">FPX&nbsp;<i class="ti-info-alt" aria-hidden="true"></i></span></p> -->

                          <p><span [attr.data-tooltip]="SERVICE_DESC['JomPAY']?.desc">JomPAY&nbsp;<i class="ti-info-alt" aria-hidden="true"></i></span></p>

                          <p><span [attr.data-tooltip]="SERVICE_DESC['AutoDebit']?.desc">AutoDebit&nbsp;<i class="ti-info-alt" aria-hidden="true"></i></span></p>

                          <p><span [attr.data-tooltip]="SERVICE_DESC['Maybank2u Biller']?.desc">Maybank2u Biller&nbsp;<i class="ti-info-alt" aria-hidden="true"></i></span></p>
                        </div>
                        
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- ***** Pricing Plane Area End ***** -->

    <!-- ***** How To Apply Start ***** -->
    <section class="how-to-apply-area section_padding_100" id="apply">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <!-- Section Heading Area -->
                    <div class="section-heading text-center">
                      <h2>How To Apply</h2>
                        <div class="line-shape"></div>
                    </div>
                    
                </div>
            </div>

            <div class="col-md-12">
                <!-- Single Special Area -->
                <div class="col-sm-12 col-md-3">
                  <div class="single-special text-center wow fadeInUp" data-wow-delay="0.2s">
                        <div class="single-icon"><img src="images/bg-img/hta1.png" alt="" class="pay-now"></div>
                        <h4><strong>STEP 1</strong></h4>
                        <p>Sign up for free &amp; apply for the payment solutions</p>
                        <br>
                  </div>
                </div>
                <!-- Single Special Area -->
                <div class="col-sm-12 col-md-3">
                    <div class="single-special text-center wow fadeInUp" data-wow-delay="0.4s">
                       <div class="single-icon"><img src="images/bg-img/hta2.png" alt="" class="pay-now"></div>
                       
                        <h4><strong>STEP 2</strong></h4>
                        <p>Tell us more about your business &amp; submit!</p>
                        <br>
                    </div>
                </div>
                <!-- Single Special Area -->
                <div class="col-sm-12 col-md-3">
                    <div class="single-special text-center wow fadeInUp" data-wow-delay="0.4s">
                       <div class="single-icon"><img src="images/bg-img/hta5.png" alt="" class="pay-now"></div>
                       
                        <h4><strong>STEP 3</strong></h4>
                        <p>We’ll email you on your application status &amp; next steps</p>
                        <br>
                    </div>
                </div>
                <!-- Single Special Area -->
                <div class="col-sm-12 col-md-3">
                    <div class="single-special text-center wow fadeInUp" data-wow-delay="0.4s">
                       <div class="single-icon"><img src="images/bg-img/hta6.png" alt="" class="pay-now"></div>
                       
                        <h4><strong>STEP 4</strong></h4>
                        <p>Integrate and use our payment solutions</p>
                        <br>
                    </div>
                </div>
                
            </div>
        </div>
      
    </section>
    <!-- ***** How to Apply End ***** -->

  
      <!-- ***** CTA Area Start ***** -->
<section class="developer section_padding_50 clearfix">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-md-8">
                  <div class="membership-description">
                    <h2>Built for Developer</h2>
                    <p>For Online Banking, the SDKs are available for Java, Javascript and PHP.<br>
                      Try our SDK and decide later if you want to sign up as a Merchant.<br><br>We also support Woocommerce Plugin &amp; Easystore Plugin.<br>
					  </p>
                  </div>
                  <div class="sdk-button">
                        <a href="/assets/sdk/index.html">TRY OUR SDK NOW</a>
                    </div>
				 </div>
                
            </div>
            
        </div>
    </section>
    <!-- ***** CTA Area End ***** -->
    
    
   
    <!-- ***** Video Area Start ***** -->
    <!-- <div class="video-section">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    
                    <div class="video-area" style="background-image: url(images/bg-img/video.jpg);">
                        
                    </div>
                </div>
            </div>
        </div>
    </div> -->
    <!-- ***** Video Area End ***** -->

    <!-- ***** Cool Facts Area Start ***** -->
    <!-- <section class="cool_facts_area clearfix">
        <div class="container">
            <div class="row">
                
                <div class="col-12 col-md-3 col-lg-3">
                    <div class="single-cool-fact d-flex justify-content-center wow fadeInUp" data-wow-delay="0.2s">
                        <div class="counter-area">
                            <h3><span class="counter">90</span></h3>
                        </div>
                        <div class="cool-facts-content">
                         <p>TOTAL <br> SIGNUPS</p>
                        </div>
                    </div>
                </div>
                
                <div class="col-12 col-md-3 col-lg-3">
                    <div class="single-cool-fact d-flex justify-content-center wow fadeInUp" data-wow-delay="0.4s">
                        <div class="counter-area">
                            <h3><span class="counter">120</span></h3>
                        </div>
                        <div class="cool-facts-content">
                           
                            <p>HAPPY<br> MERCHANTS</p>
                        </div>
                    </div>
                </div>
                
                <div class="col-12 col-md-3 col-lg-3">
                    <div class="single-cool-fact d-flex justify-content-center wow fadeInUp" data-wow-delay="0.6s">
                        <div class="counter-area">
                            <h3><span class="counter">40</span></h3>
                        </div>
                        <div class="cool-facts-content">
                            
                            <p>ACTIVE <br>ACCOUNTS</p>
                        </div>
                    </div>
                </div>
                
                <div class="col-12 col-md-3 col-lg-3">
                    <div class="single-cool-fact d-flex justify-content-center wow fadeInUp" data-wow-delay="0.8s">
                        <div class="counter-area">
                            <h3><span class="counter">10</span></h3>
                        </div>
                        <div class="cool-facts-content">
                           
                            <p>ACTIVE <br>ACCOUNTS</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section> -->
    <!-- ***** Cool Facts Area End ***** -->


    <!-- ***** Client Feedback Area Start ***** -->
<!-- <section class="clients-feedback-area bg-white section_padding_100 clearfix" id="testimonials">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-12 col-md-10">
                    <div class="slider slider-for">
                        
                        <div class="client-feedback-text text-center">
                            <div class="client">
                                <i class="fa fa-quote-left" aria-hidden="true"></i>
                            </div>
                            <div class="client-description text-center">
                                <p>“ Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. ”</p>
                            </div>
                            <div class="star-icon text-center">
                                <i class="ion-ios-star"></i>
                                <i class="ion-ios-star"></i>
                                <i class="ion-ios-star"></i>
                                <i class="ion-ios-star"></i>
                                <i class="ion-ios-star"></i>
                            </div>
                            <div class="client-name text-center">
                                <h5>Aigars Silkalns</h5>
                                <p>Ceo Colorlib</p>
                            </div>
                        </div>
                        
                        <div class="client-feedback-text text-center">
                            <div class="client">
                                <i class="fa fa-quote-left" aria-hidden="true"></i>
                            </div>
                            <div class="client-description text-center">
                                <p>“ Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. ”</p>
                            </div>
                            <div class="star-icon text-center">
                                <i class="ion-ios-star"></i>
                                <i class="ion-ios-star"></i>
                                <i class="ion-ios-star"></i>
                                <i class="ion-ios-star"></i>
                                <i class="ion-ios-star"></i>
                            </div>
                            <div class="client-name text-center">
                                <h5>Jennifer</h5>
                                <p>Developer</p>
                            </div>
                        </div>
                        
                        <div class="client-feedback-text text-center">
                            <div class="client">
                                <i class="fa fa-quote-left" aria-hidden="true"></i>
                            </div>
                            <div class="client-description text-center">
                                <p>“ The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested.”</p>
                            </div>
                            <div class="star-icon text-center">
                                <i class="ion-ios-star"></i>
                                <i class="ion-ios-star"></i>
                                <i class="ion-ios-star"></i>
                                <i class="ion-ios-star"></i>
                                <i class="ion-ios-star"></i>
                            </div>
                            <div class="client-name text-center">
                                <h5>Helen</h5>
                                <p>Marketer</p>
                            </div>
                        </div>
                        
                        <div class="client-feedback-text text-center">
                            <div class="client">
                                <i class="fa fa-quote-left" aria-hidden="true"></i>
                            </div>
                            <div class="client-description text-center">
                                <p>“ Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. ”</p>
                            </div>
                            <div class="star-icon text-center">
                                <i class="ion-ios-star"></i>
                                <i class="ion-ios-star"></i>
                                <i class="ion-ios-star"></i>
                                <i class="ion-ios-star"></i>
                                <i class="ion-ios-star"></i>
                            </div>
                            <div class="client-name text-center">
                                <h5>Henry smith</h5>
                                <p>Developer</p>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div class="col-12 col-md-6 col-lg-5">
                    <div class="slider slider-nav">
                        <div class="client-thumbnail">
                            <img src="images/bg-img/client-3.jpg" alt="">
                        </div>
                        <div class="client-thumbnail">
                            <img src="images/bg-img/client-2.jpg" alt="">
                        </div>
                        <div class="client-thumbnail">
                            <img src="images/bg-img/client-1.jpg" alt="">
                        </div>
                        <div class="client-thumbnail">
                            <img src="images/bg-img/client-2.jpg" alt="">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section> -->
    <!-- ***** Client Feedback Area End ***** -->

    <!-- ***** CTA Area Start ***** -->
    <section class="our-monthly-membership section_padding_50 clearfix" *ngIf="!authenticated">
        <div class="container">
            <div class="col-sm-12 col-md-12 align-items-center">
                <div class="col-xs-6 col-md-8">
                    <div class="membership-description">
                        <h2>Ready to get started?</h2>
                        <p>Create an account now.</p>
                    </div>
                </div>
                <div class="col-xs-6 col-md-4 align-items-center">
                    
                        <a routerLink="/register">
                           <button type="submit" class="btn submit-btn">SIGN UP NOW</button>
                        </a>
                    
                </div>
            </div>
        </div>
    </section>
    <!-- ***** CTA Area End ***** -->

    
    <!-- ***** Contact Us Area Start ***** -->
    <section class="footer-contact-area section_padding_100 clearfix" id="contact">
        <div class="container">
            <div class="col-md-12">
                <div class="col-sm-12 col-md-6">
                    <!-- Heading Text  -->
                    <div class="section-heading">
                      <h2>{{contactUsStr}}</h2>
                        <div class="line-shape"></div>
                    </div>
                    <div class="footer-text">
                        <p></p>
                    </div>
                    
                    <div class="email-text">
                        <!-- <p><span>Email:</span> <a href="mailto:maybank2upay@maybank.com">maybank2upay@maybank.com</a></p> -->
                    </div>
                </div>
                <div class="col-sm-12 col-md-6">
                    <!-- Form Start-->
                    <div class="form-row">
                        <form name="login-form" id="login-form" data-k2-validation="true"  #f="ngForm" novalidate (ngSubmit) = "onFormSubmit(f.value)">
                            <!-- Message Input Area Start -->
                            <div class="contact_input_area">
                                <div class="row">
                                    <!-- Single Input Area Start -->
                                    <div class="col-md-12">
                                        <div class="group form-group">
                                            <input type="text" class="form-control" name="name" id="name" placeholder="Your Name *" [(ngModel)]="contact.name" required data-rules="required" data-error-mes="This field is required">
                                        </div>
                                    </div>
                                    <!-- Single Input Area Start -->
                                    <div class="col-md-12">
                                        <div class="group form-group">
                                            <input type="text" class="form-control" name="email" id="email" placeholder="Your Email *" [(ngModel)]="contact.from_email" required data-rules="required|email" data-error-mes="This field is required|Email is invalid" trim>
                                        </div>
                                    </div>

                                    <div class="col-md-12">
                                      <!-- <div class="group">
                                        <div class="custom-selec style-form">
                                            <select required data-rules="required" data-error-mes="This field is required" [(ngModel)]="selectedService" name="refundPolicy" #refundPolicy="ngModel" [disabled]="prevSubmitted">
                                              
                                              <option value="-1" selected hidden>Select service</option>
                                              <option *ngFor="let service of services; let i = index;" [value]="i">{{service}}</option>
                                            </select>
                                            <label>Select your Refund Policy*</label>
                                        </div>
                                        
                                      </div> -->
                                      <div class="form-group" [ngClass]="{'error': (!valid && contact.service==null)}">
                                        <select class="form-control" id="service" name="service" required data-rules="required" data-error-mes="This field is required"
                                                [(ngModel)]="selectedService" (change)="onServicesChange()" [ngModelOptions]="{standalone: true}">
                                          <option value="-1" selected hidden>Select service</option>
                                          <option *ngFor="let service of services; let i = index;" [value]="i">{{service}}</option>
                                        </select>
                                        <p *ngIf="(!valid && contact.service==null)" class="msg-error">This field is required</p>
                                      </div>
                                      
                                    </div>
                                      
                                    <!-- Single Input Area Start -->
                                    <div class="col-md-12">
                                        <div class="group form-group">
                                            <textarea name="message" class="form-control custom-input" id="message"  cols="30" rows="4" placeholder="Your Message *" [(ngModel)]="contact.message" required data-rules="required" data-error-mes="This field is required"></textarea>
                                        </div>
                                    </div>

                                    <div class="col-md-12">
                                        <div class="group form-group" [innerHTML]="captcha">
                                        </div>
                                        <p>This question is to prevent automated spam submissions. Entries are not case sensitive.</p>
                                        <div class="group form-group">
                                        <a (click)="getCaptcha()" class="btn btn-default btn-block btn-checklist pointer bg-white" >REFRESH</a>
                                      </div>
                                    </div>
                                    <!-- Single Input Area Start -->
                                    <div class="col-md-12">
                                        <div class="group form-group">
                                            <input type="text" class="form-control" name="captcha" id="captcha" placeholder="Captcha *" [(ngModel)]="contact.bot" required data-rules="required" data-error-mes="This field is required">
                                        </div>
                                    </div>




                                    
                                    <!-- Single Input Area Start -->
                                    <div class="col-12">
                                        <button type="submit" class="btn submit-btn">SEND NOW</button>
                                    </div>
                                </div>
                            </div>
                            <!-- Message Input Area End -->
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </section>
    
    <!--<div id="contactUsPopup" class="modal hide">
      <div class="modal-content">
        <div class="modal-header"><a (click)="close()" title="Close" class="close" style="cursor: pointer" data-dismiss="modal"></a>
          <h3 class="modal-title">{{contactUsStr}}</h3>
        </div>
        <div class="modal-body">
          <div class="pop-up"><span>{{popupMsg}}</span></div>
        </div>
        <div class="modal-footer">
         <button type="button" class="btn btn-primary" (click)="close()">Close</button>
        </div>
      </div>
    </div>-->
    <!-- ***** Contact Us Area End ***** -->

